import { API } from "aws-amplify";
import { GraphQLQuery } from "@aws-amplify/api";
import { updateTransaction } from "../../graphql/mutations";
import { UpdateTransactionMutation } from "../../API";

export type MarkResult = { success: string[]; failed: string[] };

// Cap parallel updateTransaction mutations to avoid AppSync /
// DynamoDB write-capacity throttling on large monthly exports
// (accountants regularly select 100-500 transactions in one batch).
const CONCURRENCY = 10;

export const markTransactionsExported = async (
  ids: string[]
): Promise<MarkResult> => {
  const exportedAt = new Date().toISOString();
  const success: string[] = [];
  const failed: string[] = [];

  for (let i = 0; i < ids.length; i += CONCURRENCY) {
    const slice = ids.slice(i, i + CONCURRENCY);
    const settled = await Promise.allSettled(
      slice.map((id) =>
        API.graphql<GraphQLQuery<UpdateTransactionMutation>>({
          query: updateTransaction,
          variables: { input: { id, exportedAt } },
        })
      )
    );
    settled.forEach((result, index) => {
      if (result.status === "fulfilled") success.push(slice[index]);
      else failed.push(slice[index]);
    });
  }

  return { success, failed };
};
